var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cashier-login" }, [
    _c(
      "div",
      { staticClass: "login-card" },
      [
        _c("div", { staticClass: "login-title" }, [_vm._v("独立收银台")]),
        _c("div", { staticClass: "login-sub" }, [_vm._v("请输入账号密码登录")]),
        _c(
          "a-form",
          {
            attrs: { layout: "vertical" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.handleSubmit.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "a-form-item",
              [
                _c(
                  "a-input",
                  {
                    attrs: { size: "large", placeholder: "请输入账号" },
                    model: {
                      value: _vm.username,
                      callback: function ($$v) {
                        _vm.username = $$v
                      },
                      expression: "username",
                    },
                  },
                  [
                    _c("a-icon", {
                      attrs: { slot: "prefix", type: "user" },
                      slot: "prefix",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "a-form-item",
              [
                _c("a-input-password", {
                  attrs: { size: "large", placeholder: "请输入密码" },
                  model: {
                    value: _vm.password,
                    callback: function ($$v) {
                      _vm.password = $$v
                    },
                    expression: "password",
                  },
                }),
              ],
              1
            ),
            _vm.checkcodeFlag === "1"
              ? _c("a-form-item", [
                  _c(
                    "div",
                    { staticClass: "captcha-row" },
                    [
                      _c("a-input", {
                        staticStyle: { flex: "1", "min-width": "0" },
                        attrs: { size: "large", placeholder: "请输入验证码" },
                        model: {
                          value: _vm.inputCode,
                          callback: function ($$v) {
                            _vm.inputCode = $$v
                          },
                          expression: "inputCode",
                        },
                      }),
                      _vm.requestCodeSuccess
                        ? _c("img", {
                            staticClass: "captcha-img",
                            attrs: {
                              src: _vm.randCodeImage,
                              title: "点击刷新",
                            },
                            on: { click: _vm.loadCaptcha },
                          })
                        : _c(
                            "div",
                            {
                              staticClass: "captcha-fallback",
                              attrs: { title: "点击刷新" },
                              on: { click: _vm.loadCaptcha },
                            },
                            [_vm._v("刷新")]
                          ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _c(
              "a-button",
              {
                attrs: {
                  type: "primary",
                  size: "large",
                  block: "",
                  "html-type": "submit",
                  loading: _vm.loginBtn,
                },
              },
              [_vm._v("登 录")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }